@if (isLoading) {
<app-loading-spinner [text]="'Contracts'"></app-loading-spinner>
}

<div class="py-2 px-4 page-height main-bg overflow-auto">
  @if (contracts$ | async; as data) {
  <div>
    @if (data.length === 0) {
    <div class="mx-auto max-w-xl text-center text-xl font-medium">
      You don't have any contracts at the moment
    </div>
    } @for (item of data; track item) {
    <mat-card
      [routerLink]="item._id"
      matRipple
      class="pb-4 my-2 mx-auto max-w-xl hover:cursor-pointer"
    >
      <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>
            <p class="text-lg font-medium underline decoration-solid">
              Contract - {{ item.contract_number }}
            </p>
            <span class="text-lg font-medium">
              {{ item.commodity + " - " + item.grade }}
              {{ item.product_type ? " - " + item.product_type : "" }}
            </span>
          </mat-card-title>

          <span
            id="zcreated-at"
            class="text-xs self-center font-extralight hidden mobile-min:inline-block"
            >created {{ item.createdAt | date : ["MMM d, y, h:mm a"] }}
          </span>
        </mat-card-title-group>
      </mat-card-header>
      <mat-card-content class="text-sm mobile-max:text-xs">
        <div class="text-sm flex flex-row justify-between font-light">
          @if (item.buyer_id == userDetails._id) {
          <span>
            @if (item.seller_company_name) {
            <span class="mobile-max:hidden"
              >{{ item.seller_company_name }} -</span
            >
            }
            {{ item.seller_first_name }}
          </span>
          } @else {
          <span>
            @if (item.buyer_company_name) {
            <span>{{ item.buyer_company_name }} </span>
            }
            <span class="mobile-max:hidden">
              -
              {{ item.buyer_first_name + " " + item.buyer_last_name }}</span
            >
          </span>
          }
          <span class="font-medium">
            {{ item.currency }} ${{ item.price | priceType }} /
            {{ item.units }}
          </span>
        </div>
        <div class="flex flex-row justify-between">
          <span class="font-light"
            >{{ item.ship_begin | date }} - {{ item.ship_end | date }}</span
          >
          <span class="font-medium"
            >{{ item.volume_value }} {{ item.units }}
          </span>
        </div>
        <div>
          <span class="font-light">
            {{ item.destination }}
          </span>
        </div>
      </mat-card-content>
      <mat-card-footer> </mat-card-footer>
    </mat-card>
    }
  </div>
  }
</div>
